<template>
    <v-form ref="addCompanyForm"
            :disabled="isFormDisabled()"
    >
        <v-btn v-if="details.companyId"
               @click="$router.push({name: 'company-details', params: { id: details.companyId }})">przejdź do firmy
        </v-btn>

        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="details.name"
                    label="Nazwa firmy"
                    :aria-required="true"
                    :counter="254"
                />
            </v-col>
            <v-col cols="12" sm="6">
                <v-tooltip
                    top
                    :nipHint="this.nipHint"
                >
                    <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-text-field
                  v-model="details.nip"
                  label="Numer NIP"
                  append-icon="mdi-exclamation"
                  :persistent-hint="true"
                  :rules="rules.nip"
                  :counter="10"
              ></v-text-field>
            </span>
                    </template>
                    <span>
            {{ nipHint }}
          </span>
                </v-tooltip>
            </v-col>
            <v-col cols="6">
                <v-autocomplete
                    v-model="details.companyId"
                    :items="companies"
                    :item-text="item => item.id + ' - ' + item.name + ' NIP: ' + item.nip"
                    item-value="id"
                    label="Firma"
                    required
                ></v-autocomplete>
            </v-col>
            <v-col cols="12">
                <v-textarea
                    v-model="details.description"
                    label="Opis firmy"
                    rows="3"
                    :aria-required="false"
                    :counter="65535"
                />
            </v-col>
          <v-col cols="3">
            <div class="pb-0 disabled-label">
              Promowana:
            </div>
            <v-switch
                :v-model="mapBool(details.promoted, false)"
                :input-value="mapBool(details.promoted, false)"
                :value="true"
                class="mt-0 pt-0"
                :label="false !== details.promoted ? 'Tak' : 'Nie'"
                @change="onPromotedSwitched"
            />
          </v-col>
            <v-col cols="3">
                <div class="pb-0 disabled-label">
                    Widoczna w wynikach wyszukiwania:
                </div>
                <v-switch
                    :v-model="mapBool(details.public, true)"
                    :input-value="mapBool(details.public, true)"
                    :value="true"
                    class="mt-0 pt-0"
                    :label="false !== details.public ? 'Tak' : 'Nie'"
                    @change="onPublicSwitched"
                />
            </v-col>
            <v-col cols="3">
                <div class="pb-0 disabled-label">
                    Partner:
                </div>
                <v-switch
                    :v-model="mapBool(details.partner, false)"
                    :input-value="mapBool(details.partner, false)"
                    :value="true"
                    class="mt-0 pt-0"
                    :label="false !== details.partner ? 'Tak' : 'Nie'"
                    @change="onPartnerSwitched"
                />
            </v-col>
          <v-col cols="3">
            <div class="pb-0 disabled-label">
              Przypomnienie o realizacji zamówienia:
            </div>
            <v-switch
                v-model="details.orderReminder"
                class="mt-0 pt-0"
                :label="details.orderReminder ? 'Tak' : 'Nie'"
                @change="onReminderSwitched"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>Obrazki</v-card-title>
                    <vue-dropzone id="dropzone" :options="dropzoneOptions"
                                  v-on:vdropzone-success="loadImages"></vue-dropzone>
                    <v-card-text v-if="images.length">
                        <v-row>
                            <v-col
                                v-for="(image, i) in images" :key="i"
                                class="d-flex child-flex"
                                cols="4"
                            >
                                <div>
                                    <v-img v-bind:src="image.url" contain height="200"></v-img>
                                    <v-select
                                        v-model="image.type"
                                        :items="imageTypes"
                                        item-text="text"
                                        item-value="value"
                                        label="Typ obrazka"
                                        @change="changeImageType(image)"
                                    />
                                    <v-btn @click="removeImage(image.id)">Usuń</v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>
                        Brak
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="text-center">
                <v-btn
                    :disabled="saving"
                    @click="save"
                    v-if="isIdle()"
                >
                    Zapisz
                    <v-icon size="24" right>
                        mdi-content-save-outline
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import api from "@/services/api";
import {Auth} from "../../services/Auth";
import {getItems as getImageTypeItems} from "@/enums/ImageType";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        vueDropzone: vue2Dropzone,
    },
    props: {
        id: {
            type: [String],
            required: false,
            default: null,
        },
        nipHint: {
            type: [String],
            required: true,
            default: '',
        }
    },
    data() {
        return {
            default: {},
            details: {
                name: '',
                description: '',
                nip: '',
                transport: false,
                public: false,
            },
            label: {},
            rules: {
                nip: [
                    (value) => {
                        if (undefined === value || value.trim() === '') {
                            return true; // Allow this field to be empty.
                        }

                        if (!/^\d+$/.test(value)) {
                            return 'Numer NIP musi składać się wyłącznie z cyfr.';
                        }

                        return 10 === value.length || 'Numer NIP musi mieć 10 cyfr.';
                    },
                ],
            },
            loading: false,
            saving: false,
            companies: [],
            images: [],
            imageTypes: [
                ...getImageTypeItems(),
            ],
            dropzoneOptions: {
                url: `${process.env.VUE_APP_API_URL}/api/price-list/company/${this.id}/images`,
                thumbnailWidth: 150,
                maxFilesize: 1024 * 20,
                acceptedFiles: 'image/*',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
                }
            },
        };
    },
    computed: {},
    created() {
        if (this.id) {
            this.get();
            this.loadImages();
            this.loadCompanies();
        }
    },
    methods: {
        isIdle() {
            return !this.loading && !this.saving;
        },
        isFormDisabled() {
            return !this.isIdle();
        },
        isEditForm() {
            return !!this.id;
        },
        add() {
            if (this.saving) {
                return;
            }

            this.saving = true;
            const self = this;
            let details = {...this.details};

            delete details.createdAt;
            delete details.updatedAt;

            api.post(`/api/price-list/company`, details)
                .then((response) => {
                    this.details = response.data;
                    this.$root.$emit('notifySuccess', {
                        html: 'Firma została zapisana.',
                        callback: () => {
                            // The following setTimeout() call is required to render the success message for the user before
                            // displaying the built-in prompt window.
                            setTimeout(function () {
                                self.saving = false;
                                self.askForNextCompany();
                            }, 500);
                        }
                    });
                })
                .catch((error) => {
                    this.saving = false;
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się dodać firmy.',
                        error,
                    });
                });
        },
        get() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            api.get(`/api/price-list/company/${this.id}`)
                .then((response) => {
                    this.details = response.data;
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się pobrać danych firmy.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        mapBool(value, onNull = false) {
            if (null === value) {
                return onNull;
            }

            return !!value;
        },
        save() {
            if (this.saving) {
                return;
            }

            if (this.isEditForm()) {
                this.update();
            } else {
                this.add();
            }
        },
        update() {
            if (this.saving) {
                return;
            }

            this.saving = true;
            const self = this;
            let details = {...this.details};

            delete details.id;
            delete details.createdAt;
            delete details.updatedAt;

            api.put(`/api/price-list/company/${this.id}`, details)
                .then((response) => {
                    this.details = response.data;
                    this.$root.$emit('notifySuccess', {
                        html: 'Firma została zapisana.',
                        callback: () => {
                            // The following setTimeout() call is required to render the success message for the user before
                            // displaying the built-in prompt window.
                            setTimeout(function () {
                                self.saving = false;
                            }, 500);
                        }
                    });
                })
                .catch((error) => {
                    this.saving = false;
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zaktualizować danych firmy.',
                        error,
                    });
                });
        },
        askForNextCompany() {
            if (confirm('Chcesz dodać kolejną firmę?')) {
                this.clear();
            } else {
                this.$router
                    .push({name: 'price-list-companies'})
                    .catch(() => {
                    });
            }
        },
        clear() {
            this.details.name = '';
            this.details.description = '';
            this.details.nip = '';
            this.details.public = false;
        },
        onPublicSwitched(newValue) {
            this.details.public = !!newValue;
        },
        onPromotedSwitched(newValue) {
          this.details.promoted = !!newValue;
        },
        onPartnerSwitched(newValue) {
            this.details.partner = !!newValue;
        },
        onReminderSwitched(newValue) {
            this.details.orderReminder = !!newValue;
        },
        async loadImages() {
            const companyImagesResponse = await api.get(`/api/price-list/company/${this.id}/images`);
            const images = companyImagesResponse.data;

            this.images = [];
            images.forEach((image) => {
                this.images.push(image);
            });
        },
        removeImage(id) {
            api.delete(`/api/price-list/company/${this.id}/images/${id}`)
                .then(() => {
                    this.loadImages();
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się usunąć obrazka.',
                        error,
                    });
                });
        },
        changeImageType(image) {
            api.put(`/api/price-list/company/${this.id}/images/${image.id}`, image)
                .then(() => {
                    this.loadImages();
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zmienić typu obrazka.',
                        error,
                    });
                });
        },
        loadCompanies() {
            const params = {
                limit: 5000,
            };

            api
                .get("/api/companies", {params})
                .then((response) => {
                    this.companies = response.data.items;
                })
                .catch((error) => {
                    this.$root.$emit("notifyError", {
                        html: "Nie udało się pobrać listy firm.",
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
}
</script>